<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="actions"
    :form="form"
    :title="$t('model.frequentlyAskedQuestion')"
    resource="frequently_asked_questions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/frequently_asked_questions.js';

@Component
export default class FrequentlyAskedQuestions extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'question_cont',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'question',
      'position',
      type === 'show' && { key: 'answer', renderCell: { component: 'html' } },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'question',
      { key: 'answer', renderCell: { component: 'editor' } },
      'position',
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'frequently_asked_questions.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'frequently_asked_questions.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/frequently_asked_questions',
    name: 'frequently_asked_questions.index',
    component: FrequentlyAskedQuestions,
    props: {
      type: 'index',
    }
  },
  {
    path: '/frequently_asked_questions/new',
    name: 'frequently_asked_questions.new',
    component: FrequentlyAskedQuestions,
    props: {
      type: 'new',
    }
  },
  {
    path: '/frequently_asked_questions/:id',
    name: 'frequently_asked_questions.show',
    component: FrequentlyAskedQuestions,
    props: {
      type: 'show',
    }
  },
  {
    path: '/frequently_asked_questions/:id/edit',
    name: 'frequently_asked_questions.edit',
    component: FrequentlyAskedQuestions,
    props: {
      type: 'edit'
    }
  }
]
</script>
